import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { LoadingBubblesProps } from './types';
import './index.less';

const Bubbles = ({ active = true, color = 'primary' }: LoadingBubblesProps) => {
  return (
    <div className="loading-bubbles">
      <div
        className={clsx('bubblesItem', 'bubblesItem0', [color], {
          active,
        })}
      />
      <div
        className={clsx('bubblesItem', 'bubblesItem1', [color], {
          active,
        })}
      />
      <div
        className={clsx('bubblesItem', 'bubblesItem2', [color], {
          active,
        })}
      />
    </div>
  );
};

export default Bubbles;
